import { render, staticRenderFns } from "./ClimateDetails.vue?vue&type=template&id=46f70f92&scoped=true&"
import script from "./ClimateDetails.vue?vue&type=script&lang=js&"
export * from "./ClimateDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClimateDetails.vue?vue&type=style&index=0&id=46f70f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f70f92",
  null
  
)

export default component.exports